module.exports = __webpack_public_path__ + "img/avatar-17.177df1a0.png";